/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { changeTimeframe, getProductById } from 'actions';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import AnalyticsDateRangePicker from '../../../search/analytic/components/AnalyticsDateRangePicker';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import TrendingWidget from './TrendingWidget';
import ProductDetail from './ProductDetail';
import RelatedProductsByView from './RelatedProductsByView';
import RelatedProductsByPurchase from './RelatedProductsByPurchase';
import RelatedQueries from './RelatedQueries';
import StatsWidget from './StatsWidget';
import DiscoveryWidget from './DiscoveryWidget';

const Product = ({ match }) => {
  const { params: { productId } } = match;
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const {
    catalog: { product },
    app: { currentShop },
    analytics: { timeframe },
  } = useSelector((str) => str);
  const { data, stats } = product;

  useEffect(() => {
    dispatch(getProductById(currentShop, timeframe, productId));
  }, [timeframe, productId]);

  const onTimeframeSubmit = (newRange) => dispatch(changeTimeframe(newRange));
  const timeframePicker = (
    <AnalyticsDateRangePicker
      timeframe={timeframe}
      onSubmitRange={onTimeframeSubmit}
    />
  );

  return (
    <FeaturePageShell
      title={(data && data.name) || localizeMessage('catalog.product.detail.fallbackTitle')}
      description={localizeMessage('catalog.product.detail.description')}
      actions={timeframePicker}
      width="expanded"
    >
      <Grid container spacing={3}>
          <Grid xs={12} lg={4} item>
            <Grid container spacing={3}>

              <Grid item xs={12}>
                <ProductDetail match={match} product={product} />
              </Grid>

              <Grid item xs={12}>
                <RelatedQueries productId={match.params.productId} />
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} lg={8}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <StatsWidget stats={stats} />
              </Grid>

              <Grid item xs={12} md={6}>
                <DiscoveryWidget stats={stats} />
              </Grid>

              <Grid item xs={12}>
                <TrendingWidget match={match} chartData={product.trendingCurve} />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <RelatedProductsByView productId={productId} />
              </Grid>

              <Grid item xs={12} md={6}>
                <RelatedProductsByPurchase productId={productId} />
              </Grid>
            </Grid>

          </Grid>

      </Grid>
    </FeaturePageShell>
  );
};

export default Product;
